import React from "react";
import AppLogo from "../../assets/logo.svg";
import "./styles.css";
import Button from "../buttons/Button";

const AcknowledgementModal = ({
  username,
  acknowledgementContent,
  primaryButtonText,
  secondaryButtonText,
  onAcknowledgeClick = () => {},
  onDeclineClick = () => {},
}) => {
  return (
    <div className="acknowledgement-container">
      <div className="modal">
        <div className="content-wrapper">
          <img src={AppLogo} alt="app logo" width={48} height={48} />
          <div className="greeting">Hello {username}! </div>
          <div className="acknowledgement-content">
            {acknowledgementContent}
          </div>
        </div>
        <div className="buttons-wrapper">
          <Button
            text={primaryButtonText}
            onClick={onAcknowledgeClick}
            variant="primary"
          />
          <Button
            text={secondaryButtonText}
            onClick={onDeclineClick}
            variant="secondary"
          />
        </div>
      </div>
    </div>
  );
};

export default AcknowledgementModal;
